import {
  createRootRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { ChatWidget } from "@/features/chat/chat-widget";
import { AppProviders } from "@/app/providers";

export const Route = createRootRoute({
  component: RootLayout,
});

/**
 * Just providers here. The stepper graph is loaded by the funnel player route
 * (`/`) via its own StepperGate — standalone routes like `/key-handoff` render
 * without touching the stepper (no graph load, no journey logging).
 */
function RootLayout() {
  const editor = useRouterState({
    select: (state) =>
      /^\/(?:secretmissions\/)?(?:misionbankeditor|b|beta|beta-admin)\/?$/.test(
        state.location.pathname,
      ),
  });
  return (
    <AppProviders>
      <Outlet />
      {!editor && <ChatWidget />}
    </AppProviders>
  );
}
